import { Component, Input } from '@angular/core'
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms'
import { ErrorStateMatcher } from '@angular/material/core'
import { FormFieldComponent } from '../form-field/form-field.component'

@Component({
  selector: 'bdg-input-field',
  templateUrl: './input-field.component.html',
})
export class InputFieldComponent extends FormFieldComponent implements ErrorStateMatcher {
  @Input()
  mask: string
  @Input()
  maxLength = 5000
  @Input()
  matPrefixIcon: string

  public customPatterns = {
    0: { pattern: new RegExp('[0-9]') },
    1: { pattern: new RegExp('[1-9]') },
  }

  constructor() {
    super()
  }

  error() {
    return this.control && this.control.touched && this.control.errors?.error
  }

  isErrorState(_: FormControl, form: FormGroupDirective | NgForm): boolean {
    return this.error()
  }

  get matcher() {
    return this as ErrorStateMatcher
  }

  @Input() set disable(value: boolean) {
    if (value) {
      this.control.disable()
    } else {
      this.control.enable()
    }
  }
}
